export const DEEPSEEK_ANTHROPIC_RAW_MODEL_EVENT_SOURCE = 'deepseek_anthropic';
